import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const headerLinks = [
  {
    label: "Customer support",
    path: "/owners#mobile-widget",
    Icon: require("assets/img/png/menubar/customersupport.png"),
    action: () => {
      (window as any)?.tidioChatApi?.show();
      (window as any)?.tidioChatApi?.open();
    },
  },
];

const menuNavLinks: any = {
  1: [
    {
      label: "My Profile",
      path: "/profile",
      Icon: require("assets/img/png/menubar/Profile.png"),
    },
    {
      label: "Dashboard",
      path: "/dashboard",
      Icon: require("assets/img/png/menubar/Dashboard.png"),
    },
    {
      label: "Rental History",
      path: "/rental",
      Icon: require("assets/img/png/menubar/RentalHistory.png"),
    },
    {
      label: "My Listing",
      path: "/listing",
      Icon: require("assets/img/png/menubar/Listing.png"),
    },
    {
      label: "Messages",
      path: "/messages",
      Icon: require("assets/img/png/menubar/mesaging.png"),
    },
    {
      label: "Documents",
      path: "/documents",
      Icon: require("assets/img/png/menubar/docs.png"),
    },
    {
      label: "Saved Address",
      path: "/saved-address",
      Icon: require("assets/img/png/menubar/location.png"),
    },
    {
      label: "Approval Policy",
      path: "/approval-policy",
      Icon: require("assets/img/png/menubar/approval_policy.png"),
    },
    {
      label: "Logout",
      path: "/logout",
      Icon: require("assets/img/png/menubar/logout.png"),
      color: "#D21A00",
    },
  ],
  2: [
    {
      label: "My Profile",
      path: "/profile",
      Icon: require("assets/img/png/menubar/Profile.png"),
    },

    {
      label: "Booking History",
      path: "/booking-history",
      Icon: require("assets/img/png/menubar/bookingHist.png"),
    },
    {
      label: "Saved Cards",
      path: "/saved-cards",
      Icon: require("assets/img/png/menubar/savedCard.png"),
    },
    {
      label: "Messages",
      path: "/messages",
      Icon: require("assets/img/png/menubar/mesaging.png"),
    },

    {
      label: "Saved Address",
      path: "/saved-address",
      Icon: require("assets/img/png/menubar/location.png"),
    },

    {
      label: "Logout",
      path: "/logout",
      Icon: require("assets/img/png/menubar/logout.png"),
    },
  ],
};

const authLinks = [
  { label: "Login", path: "/signin", Icon: LoginIcon },
  { label: "Signup", path: "/signup", Icon: PersonAddIcon },
];

export { authLinks, headerLinks, menuNavLinks };
